import React from 'react';
import './Footer.sass';

import * as Cookie from 'js-cookie';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { fetchRootTaxonChildren } from '../../ducks/taxons';
import { taxonNestedSet } from '../../utils/taxons';

import ChannelLink from '../../containers/channelUtils/ChannelLink';

import footerBg from './assets/footer.jpg';
import footerBgWebp from './assets/footer.webp';

import visa from './assets/payments/visa.svg';
import mastercard from './assets/payments/mastercard.svg';
import applePay from './assets/payments/apple-pay.svg';
import googlePay from './assets/payments/google-pay.svg';
import skrill from './assets/payments/skrill.svg';
import trustly from './assets/payments/trustly.svg';
import sofort from './assets/payments/sofort.svg';
import eps from './assets/payments/eps.svg';
import bancontact from './assets/payments/bancontact.svg';
import ideal from './assets/payments/ideal.svg';

import footerLogo from './assets/logo_footer.svg';
import discordLogo from '../../assets/images/social/discord.svg';

@connect(({ taxons }) => ({
  categories: taxons.root.children,
}))
export default class Footer extends React.PureComponent {
  static fetchData = ({ dispatch, categories }) =>
    categories === undefined && dispatch(fetchRootTaxonChildren());

  componentDidMount() {
    Footer.fetchData(this.props);
  }

  componentDidUpdate() {
    Footer.fetchData(this.props);
  }

  render() {
    const { menu, categories } = this.props;

    if (!categories) {
      return false;
    }

    let categoryTree = taxonNestedSet.nest(categories);

    if (Cookie.get('blacklist')) {
      const excludedTaxons = JSON.parse(Cookie.get('blacklist'));

      categoryTree =
        categoryTree && categoryTree.filter(({ slug }) => !excludedTaxons.includes(slug));
    }

    return (
      <div className="app-footer">
        <div className="footer__bg">
          <picture>
            <source srcSet={footerBgWebp} type="image/webp" />
            <source srcSet={footerBg} type="image/jpeg" />
            <img alt="Footer background" loading="lazy" src={footerBg} />
          </picture>
        </div>

        <footer className="footer">
          <div className="footer__row  footer__row--top">
            <div className="footer__logo-wrap">
              <ChannelLink to="/" aria-label="To homepage">
                <img
                  alt="Boosthive"
                  loading="lazy"
                  width={230}
                  height={36}
                  className="footer__logo"
                  src={footerLogo}
                />
              </ChannelLink>

              <p className="footer__copyright">
                <FormattedHTMLMessage id="section.footer.contacts" />
              </p>
            </div>

            <div className="footer__list">
              <div className="footer__header">
                <FormattedMessage id="section.footer.information" />
              </div>
              <div className="footer__list-wrap">
                {menu &&
                  menu.map(({ code, name, page }, idx) => (
                    <ChannelLink
                      key={code || idx}
                      className="footer__link"
                      to={'/page/' + page.slug}
                    >
                      {name}
                    </ChannelLink>
                  ))}
                <a
                  className="footer__link"
                  href="/work-with-us"
                >
                  Work with us
                </a>
                <a
                  className="footer__link  footer__link--icon"
                  href="mailto:support@boosthive.eu"
                  target="_blank"
                  rel="nofollow"
                >
                  support@boosthive.eu
                </a>
              </div>
            </div>

            {categoryTree &&
              categoryTree.slice(0, 3).map((category) => {
                const children = category.children || [];

                return(
                  <div key={category.code} className="footer__list">
                    <div className="footer__header">
                        <ChannelLink key={category.code} to={`/${category.slug}`}>
                          {category.name}
                        </ChannelLink>
                    </div>

                    <div className="footer__list-wrap">
                      {children.map(({ code, name, slug }, idx) => (
                        <ChannelLink key={code || idx} className="footer__link" to={`/${slug}`}>
                          {name}
                        </ChannelLink>
                      ))}
                    </div>
                  </div>
                );
              })}
          </div>

          <div className="footer__games-wrapper">
            <div className="footer__list  footer__list--soc">
              <div className="footer__header">
                <FormattedMessage id="section.footer.social" />
              </div>
              <div className="footer__list-wrap">
                <a
                  className="footer__link  footer__link--icon"
                  href="https://discord.com/invite/d5ZW2Ecwdt"
                  target="_blank"
                  rel="nofollow"
                >
                  <span className="footer__icon">
                    <img
                      alt="Discord tag"
                      loading="lazy"
                      src={discordLogo}
                      width={22}
                      height={22}
                    />
                  </span>
                  Discord
                </a>

                <a
                  className="footer__link  footer__link--icon"
                  href="https://www.facebook.com/boosthive/"
                  target="_blank"
                  rel="nofollow"
                  aria-label="Facebook"
                >
                  <span className="footer__icon">
                    <span className="footer__icon-facebook" />
                  </span>
                  <span>Facebook</span>
                </a>
                <a
                  className="footer__link  footer__link--icon"
                  href="https://www.instagram.com/boosthive.eu/"
                  target="_blank"
                  rel="nofollow"
                  aria-label="Instagram"
                >
                  <span className="footer__icon">
                    <span className="footer__icon-instagram" />
                  </span>
                  <span>Instagram</span>
                </a>
                <a
                  className="footer__link  footer__link--icon"
                  href="https://twitter.com/boosthive/"
                  target="_blank"
                  rel="nofollow"
                  aria-label="Twitter"
                >
                  <span className="footer__icon">
                    <span className="footer__icon-twitter" />
                  </span>
                  <span>Twitter</span>
                </a>
              </div>
            </div>

            <div>
              <div className="footer__header">Other Games</div>
              {categoryTree && (
                <div className="footer__row  footer__row--other-games  footer__other-games">
                  {categoryTree.slice(3).map(({ code, name, slug }, idx) => (
                    <ChannelLink
                      key={code || idx}
                      className="footer__link  footer__other-game"
                      to={`/${slug}`}
                    >
                      {name}
                    </ChannelLink>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div className="footer__row  footer__row--payments">
            <div className="footer-payments">
              <div className="footer-payments__list">
                <img
                  alt="Visa"
                  loading="lazy"
                  width={48}
                  height={32}
                  className="footer-payments__image"
                  src={visa}
                />
                <img
                  alt="Mastercard"
                  loading="lazy"
                  width={48}
                  height={32}
                  className="footer-payments__image"
                  src={mastercard}
                />
                <img
                  alt="Apple Pay"
                  loading="lazy"
                  width={48}
                  height={32}
                  className="footer-payments__image"
                  src={applePay}
                />
                <img
                  alt="Google Pay"
                  loading="lazy"
                  width={48}
                  height={32}
                  className="footer-payments__image"
                  src={googlePay}
                />
                <img
                  alt="Skrill"
                  loading="lazy"
                  width={48}
                  height={32}
                  className="footer-payments__image"
                  src={skrill}
                />
                <img
                  alt="Trustly"
                  loading="lazy"
                  width={48}
                  height={32}
                  className="footer-payments__image"
                  src={trustly}
                />
                <img
                  alt="Sofort"
                  loading="lazy"
                  width={48}
                  height={32}
                  className="footer-payments__image"
                  src={sofort}
                />
                <img
                  alt="Eps Überweisung"
                  loading="lazy"
                  width={48}
                  height={32}
                  className="footer-payments__image"
                  src={eps}
                />
                <img
                  alt="Bancontact"
                  loading="lazy"
                  width={48}
                  height={32}
                  className="footer-payments__image"
                  src={bancontact}
                />
                <img
                  alt="iDEAL"
                  loading="lazy"
                  width={48}
                  height={32}
                  className="footer-payments__image"
                  src={ideal}
                />
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/footer/Footer.js